// What a clip delete would break, for the delete confirms in AssetGrid and
// ContentBrowser. The AAM's GET /api/animations/{id}/used-by lists the live
// gestures and prefabs that point at a clip; deleting one of those clips left a
// myra prefab failing on every play from August to October 2026 with nobody
// warned. The check is advisory: when it fails the confirm says so and the
// delete still goes ahead on confirm.

const MAX_USAGE_LINES = 8

function usageLines(usage) {
  return ['gestures', 'prefabs'].flatMap(kind =>
    (usage?.[kind] ?? []).map(row =>
      `Used by ${kind === 'gestures' ? 'gesture' : 'prefab'} "${row.name}" on ${row.characterSlug} (${row.field})`))
}

function capLines(lines) {
  return lines.length > MAX_USAGE_LINES
    ? [...lines.slice(0, MAX_USAGE_LINES), `…and ${lines.length - MAX_USAGE_LINES} more`]
    : lines
}

export function describeClipUsage(usage) {
  return capLines(usageLines(usage))
}

// Check every clip even after the display limit is reached. Failures are advisory.
export async function clipDeleteWarning(assets, fetcher) {
  const clips = assets.filter(a => a.kind === 'body_anim' || a.kind === 'face_anim')
  const checked = await Promise.all(clips.map(async clip => {
    try { return { clip, rows: usageLines(await fetcher(clip.rawId)) } }
    catch { return { clip, rows: [], unchecked: true } }
  }))
  const lines = []
  let shown = 0
  let omitted = 0
  for (const { clip, rows } of checked) {
    const visible = rows.slice(0, MAX_USAGE_LINES - shown)
    if (visible.length) {
      lines.push(`${clip.name} is still used — deleting it will break these:`, ...visible, '')
      shown += visible.length
    }
    omitted += rows.length - visible.length
  }
  if (lines.at(-1) === '') lines.pop()
  if (omitted) lines.push(`…and ${omitted} more`)
  return { lines, unchecked: checked.some(result => result.unchecked) }
}

export async function clipDeleteBody(assets, body, fetcher) {
  const { lines, unchecked } = await clipDeleteWarning(assets, fetcher)
  if (lines.length) body += `\n\n${lines.join('\n')}`
  if (unchecked) body += '\n\nCould not check whether anything still uses this clip.'
  return body
}
